var _path, _path2, _ellipse, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 15.8889C22 21.964 17.0751 26.8889 11 26.8889C4.92487 26.8889 0 21.964 0 15.8889C0 9.81376 4.92487 0 11 0C17.0751 0 22 9.81376 22 15.8889Z",
    fill: "url(#paint0_radial_1066_3963)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7782 9.77778C20.7782 15.1779 16.4006 22 11.0004 22C5.60032 22 1.22266 15.1779 1.22266 9.77778C1.22266 4.37766 5.60032 0 11.0004 0C16.4006 0 20.7782 4.37766 20.7782 9.77778Z",
    fill: "url(#paint1_radial_1066_3963)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9998,
    cy: 8.43333,
    rx: 8.06667,
    ry: 8.43333,
    fill: "url(#paint2_radial_1066_3963)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9998,
    cy: 6.72222,
    rx: 7.33333,
    ry: 6.72222,
    fill: "url(#paint3_radial_1066_3963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1066_3963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11 15.8889) rotate(90) scale(11)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FFD67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C78800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1066_3963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0004 8.31111) rotate(90) scale(11.2444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B47D06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1066_3963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9998 4.74375) rotate(90) scale(12.1229 11.5958)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC248"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1066_3963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9998 3.78125) rotate(90) scale(9.66319 10.5417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC248"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.906c5fc5d44096e9d6aa2d0a82c00f90.svg";
export { ForwardRef as ReactComponent };